import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-8 w-full min-w-0 rounded-[5px] border border-rule bg-field px-2.5 py-1 text-[13px] text-ink shadow-[inset_0_1px_1px_rgb(16_20_27/0.04)] transition-[border-color,box-shadow] outline-none",
        "placeholder:text-ink-3 hover:border-rule-strong",
        "focus-visible:border-brand focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/25",
        "disabled:cursor-not-allowed disabled:bg-raised disabled:text-ink-3",
        "aria-invalid:border-bad aria-invalid:ring-2 aria-invalid:ring-bad/20",
        "file:mr-2 file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-[12px] file:font-medium file:text-ink",
        className
      )}
      {...props}
    />
  )
}

export { Input }
